import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";

type Props = {
  children: ReactNode;
};

export const HeaderPortal: FC<Props> = (props) => {
  return createPortal(
    props.children,
    document.getElementById('header-portal') as Element
  )
}